/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1463
 */

module.exports = {
  L: 1,
  M: 0,
  Q: 3,
  H: 2
}
